const usersState = {
    failedToInviteUsers: [],
    requestingInviteUser: false,
    requestingInviteUsers: false,
    requestingRemoveUsers: false,
    requestingUpdateUserAuthConnection: false,
    requestingUserRoles: false,
    requestingUsers: false,
    users: []
};
export default usersState;
